class TasacionesFunnelStep1 extends TasacionesFunnelManager {

    typeRequest = 'osm';
    typingTimer = 0;
    isSubmiting = false;
    currentAddressRequest = null; // Nueva propiedad para almacenar la petición actual de dirección
    currentCatastroRequest = null; // Nueva propiedad para almacenar la petición actual de catastro

    stateIntroduction = 'manual';

    oldAddress = null;
    selectedReference = null;

    constructor() {
        super({
            stepNumber: 1,
            nextStepUrl: TasacionesConf.step2_url || '#'
        });
        
        this.addressValidator = new AddressValidator();
        this.formValidator = new FormValidator();
        this.initStep1Elements();
        
        // Llamar bindEvents DESPUÉS de inicializar elementos
        this.bindEvents();

        // Establecer estado inicial: 
        // - si no hay datos, no hacer nada.
        // - si hay datos, visualizar las cajas correspondientes (debería haber una dirección correcta)
        this.initState();
    }

    initStep1Elements() {
        this.elements = {
            // Formulario principal
            form: document.getElementById('tasaciones-funnel-step-1'),
            submitBtn: document.getElementById('submit-btn-step-1'),

            orderId: document.getElementById('tasaciones_order_id'),
            
            // Bloques principales
            rcBlock: document.getElementById('tf-address-try'), // Bloque completo de búsqueda de address
            addressBlock: document.getElementById('address-result'), // Address wrapper
            addressResultQuestion: document.getElementById('tasaciones-address-result-question'), // Hay address
            addressResultNoAddress: document.getElementById('tasaciones-address-result-no-address'), // No hay address
            addressResultAddress: document.getElementById('tasaciones-address-result-address'), // Address OK
            addressResultManualEdit: document.getElementById('tasaciones-address-result-manual-edit'), // Address manual edit
            addressSelectionBlock: document.getElementById('tasaciones-address-selection'), // Address selection
            addressSelectionOptions: document.getElementById('tasaciones-address-options'), // Address options

            osmSelectionBlock: document.getElementById('tasaciones-osm-selection'), // OSM selection block
            osmSelectionOptions: document.getElementById('tasaciones-osm-options'), // OSM options
            escPisoPuertaBlock: document.getElementById('tasaciones-esc-piso-puerta'), // Escalera, piso y puerta

            // Manual edit
            manualEditBtn: document.getElementById('tasaciones-manual-edit'),

            osmResultsText: document.getElementById('tasaciones-osm-texto'),



            
            // Inputs de dirección
            direccionRC: document.getElementById('direccion_rc'),
            addressYesNoRadios: document.querySelectorAll('input[name="address_check"]'),
            foundAddress: document.getElementById('found-address'),
            provincia: document.getElementById('provincia'),
            municipio: document.getElementById('municipio'),

            codigoPostal: document.getElementById('codigo_postal'),
            dirTipoVia: document.getElementById('dir_tipo_via'),
            dirNombreVia: document.getElementById('dir_nombre_via'),
            dirNumero: document.getElementById('dir_numero'),
            dirEscalera: document.getElementById('dir_escalera'),
            dirPlanta: document.getElementById('dir_planta'),
            dirPuerta: document.getElementById('dir_puerta'),

            dirNumero2: document.getElementById('dir_numero2'),
            dirEscalera2: document.getElementById('dir_escalera2'),
            dirPlanta2: document.getElementById('dir_planta2'),
            dirPuerta2: document.getElementById('dir_puerta2'),
            
            
            // Campos ocultos y de datos

            firstStepUrl: document.getElementById('first_step_url'),
            firstStepTitle: document.getElementById('first_step_title'),

            referenciaCatastral: document.getElementById('referencia_catastral'),
            
            uso: document.getElementById('uso'),
            superficieCatastro: document.getElementById('superficie_catastro'),
            coeficienteParticipacion: document.getElementById('coeficiente_participacion'),
            anoConstruccion: document.getElementById('ano_construccion'),
            
            recibirInformeCheckbox: document.getElementById('recibir_informe'),
            moreLegalesBtn: document.getElementById('tasaciones-legales-icon'),
            legalesContainer: document.getElementById('tasaciones-legales-wrapper'),
            legalesContainerCheckboxes: document.querySelectorAll('#tasaciones-legales-wrapper input[type="checkbox"]'),

            // Campos de UTM
            utmSource: document.getElementById('utm_source'),
            utmMedium: document.getElementById('utm_medium'),
            utmCampaign: document.getElementById('utm_campaign'),
            utmTerm: document.getElementById('utm_term'),
            utmContent: document.getElementById('utm_content'),
        };
        

    }

    initState() {

        // La atribución se captura en servidor y se recupera del contexto persistido.

        // Si los campos firstStepUrl y firstStepTitle están vacíos los seteamos con los valores de la página actual
        if (this.elements.firstStepUrl && !this.elements.firstStepUrl.value) {
            this.elements.firstStepUrl.value = window.location.href;
        }
        if (this.elements.firstStepTitle && !this.elements.firstStepTitle.value) {
            this.elements.firstStepTitle.value = document.title;
        }
        console.log('firstStepUrl', this.elements.firstStepUrl.value);
        console.log('firstStepTitle', this.elements.firstStepTitle.value);


        if (this.elements.moreLegalesBtn){
            this.legalesOpenIconText = '<span class="tasaciones-tooltip-icon">×</span>';
            this.legalesOriginalIconHTML = this.elements.moreLegalesBtn.innerHTML;
        }

        this.hideAllBlocks();

        if (!this.elements.orderId || this.elements.orderId.getAttribute('data-value') === '') {
            return;
        }
        let address = {
            referencia_catastral: this.elements.referenciaCatastral.value,
            direccion_completa: '',
            partes_direccion: {
                codigo_postal: this.elements.codigoPostal.value,
                provincia: this.elements.provincia.value,
                municipio: this.elements.municipio.value,
                tipo_via: this.elements.dirTipoVia.value,
                nombre_via: this.elements.dirNombreVia.value,
                numero: this.elements.dirNumero.value,
                escalera: this.elements.dirEscalera.value,
                planta: this.elements.dirPlanta.value,
                puerta: this.elements.dirPuerta.value,
            },
            info: {
                uso: this.elements.uso.value,
                superficie: this.elements.superficieCatastro.value,
                coeficiente_participacion: this.elements.coeficienteParticipacion.value,
                ano_construccion: this.elements.anoConstruccion.value,
            }
        };

        address.direccion_completa = this.generateFullAddress(address);

        this.setSelectedAddress(address);
        DOMHelpers.setHTML(this.elements.foundAddress, address.direccion_completa);
        this.showAddressOKBlock();

        this.validateForm();
    }

    // Sobrescribir el método bindEvents de la clase padre
    bindEvents() {
        // Botón de verificar dirección
        if (this.elements.direccionRC) {
            this.elements.direccionRC.addEventListener('input', () => {
                clearTimeout(this.typingTimer);
                this.typingTimer = setTimeout(() => this.handleAddressCheck(), 500);
            });
        }

        // Validar formulario cada vez que un campo pierde el foco
        if (this.elements.form) {
            this.elements.form.querySelectorAll('input, select').forEach(input => {
                input.addEventListener('blur', (e) => this.validateFormField(e.target));
                input.addEventListener('keyup', (e) => this.validateFormField(e.target));
            });
        }

        
        // Formulario principal
        if (this.elements.form) {
            this.elements.form.addEventListener('submit', (e) => this.handleFormSubmit(e));
        }

        if (this.elements.addressYesNoRadios) {
            this.elements.addressYesNoRadios.forEach(radio => {
                radio.addEventListener('change', () => this.handleAddressYesNoCheck());
            });
        }

        // Legales
        if (this.elements.moreLegalesBtn) {
            this.elements.moreLegalesBtn.addEventListener('click', () => this.handleMoreLegales());
        }
        if (this.elements.recibirInformeCheckbox) {
            this.elements.recibirInformeCheckbox.addEventListener('change', () => this.handleRecibirInformeChange());
        }
        if (this.elements.legalesContainerCheckboxes){
            this.elements.legalesContainerCheckboxes.forEach(checkbox => {
                checkbox.addEventListener('change', (e) => this.handleLegalesChange(e.target));
            });
        }

        if (this.elements.addressSelectionOptions) {
            this.elements.addressSelectionOptions.addEventListener('click', (e) => {
                if (e.target.closest('.tasaciones-address-option')) {
                    this.handleAddressSelection(e);
                }
            });
        }

        if (this.elements.osmSelectionOptions) {
            this.elements.osmSelectionOptions.addEventListener('click', (e) => {
                if (e.target.closest('.tasaciones-osm-option')) {
                    this.handleOSMAddressSelection(e);
                }
            });
        }

        // Manual edit
        if (this.elements.manualEditBtn) {
            this.elements.manualEditBtn.addEventListener('click', () => {
                // Seleccionar opción "No"
                DOMHelpers.setRadioValue(this.elements.addressYesNoRadios, '0');
                this.showAddressManualNoQuestionBlock();
            });
        }
    }

    hideAllBlocks(){
        DOMHelpers.hide(this.elements.addressBlock);
        DOMHelpers.hide(this.elements.addressResultQuestion);
        DOMHelpers.hide(this.elements.addressResultNoAddress);
        DOMHelpers.hide(this.elements.addressResultAddress);
        DOMHelpers.hide(this.elements.addressResultManualEdit);
        DOMHelpers.hide(this.elements.addressSelectionBlock);
        DOMHelpers.hide(this.elements.osmSelectionBlock);
        DOMHelpers.hide(this.elements.escPisoPuertaBlock);
        // DOMHelpers.setDisabled(this.elements.direccionRC, false);
        this.elements.addressBlock.classList.remove('success');
    }
    showAddressOKBlock(){
        this.hideAllBlocks();
        DOMHelpers.show(this.elements.addressBlock);
        DOMHelpers.show(this.elements.addressResultQuestion);
        DOMHelpers.show(this.elements.addressResultAddress);
        this.elements.addressBlock.classList.add('success');
    }
    showAddressNoAddressBlock(){
        this.hideAllBlocks();
        this.clearSelectedAddress();
        DOMHelpers.show(this.elements.addressBlock);
        DOMHelpers.show(this.elements.addressResultNoAddress);
        DOMHelpers.show(this.elements.addressResultManualEdit);
    }
    showAddressManualBlock(){
        this.hideAllBlocks();
        this.clearSelectedAddress();
        DOMHelpers.show(this.elements.addressBlock);
        DOMHelpers.show(this.elements.addressResultQuestion);
        DOMHelpers.show(this.elements.addressResultManualEdit);
        // DOMHelpers.setDisabled(this.elements.direccionRC, true);
        this.stateIntroduction = 'manual';
    }
    showAddressManualNoQuestionBlock(){
        this.hideAllBlocks();
        this.clearSelectedAddress();
        DOMHelpers.show(this.elements.addressBlock);
        // DOMHelpers.show(this.elements.addressResultQuestion);
        DOMHelpers.show(this.elements.addressResultManualEdit);
        // DOMHelpers.setDisabled(this.elements.direccionRC, true);
        this.stateIntroduction = 'manual';
    }
    showAddressManualEditOnError(){
        this.hideAllBlocks();
        DOMHelpers.show(this.elements.addressBlock);
        DOMHelpers.show(this.elements.addressResultManualEdit);
        this.stateIntroduction = 'manual';
    }
    showAddressSelectionBlock(){
        this.hideAllBlocks();
        DOMHelpers.show(this.elements.addressBlock);
        DOMHelpers.show(this.elements.addressResultQuestion);
        DOMHelpers.show(this.elements.addressResultAddress);
        DOMHelpers.show(this.elements.addressSelectionBlock);
    }
    showOSMSelectionBlock(){
        this.hideAllBlocks();
        DOMHelpers.show(this.elements.addressBlock);
        DOMHelpers.show(this.elements.osmSelectionBlock);
    }
    showExtraFormBlock(){
        this.hideAllBlocks();
        DOMHelpers.show(this.elements.addressBlock);
        DOMHelpers.show(this.elements.addressResultAddress);
        DOMHelpers.show(this.elements.escPisoPuertaBlock);
        this.elements.addressBlock.classList.add('success');
        this.stateIntroduction = 'osm';
    }

    showDivAddressLoading(){
        DOMHelpers.show(this.elements.addressBlock);
        this.showAddressLoading(true);
    }
    hideDivAddressLoading(){
        this.showAddressLoading(false);
    }

    generateFullAddress(address) {
        let direccion = '';
        
        if (address.partes_direccion.tipo_via) {
            direccion += address.partes_direccion.tipo_via + ' ';
        }
        if (address.partes_direccion.nombre_via) {
            direccion += address.partes_direccion.nombre_via + ', ';
        }
        if (address.partes_direccion.numero) {
            direccion += address.partes_direccion.numero + ', ';
        }
        
        let shortAddress = this.generateShortAddressForSelection(address);
        if (shortAddress) {
            direccion += '<span class="tasaciones-address-option-piso">'+ shortAddress + '</span>, ';
        }

        if (address.partes_direccion.municipio) {
            direccion += address.partes_direccion.municipio + ', ';
        }
        if (address.partes_direccion.provincia) {
            direccion += address.partes_direccion.provincia + ', ';
        }
        if (address.partes_direccion.codigo_postal) {
            direccion += address.partes_direccion.codigo_postal;
        }

        return direccion.replace(/,\s*$/, '');
    }

    generateOSMAddress(address) {
        if (!address) return "";

        
        const partes = [];

        // Calle y número
        if (address.road || address.pedestrian || address.footway || address.path) {
            const via = address.road || address.pedestrian || address.footway || address.path;
            const numero = address.house_number ? ` ${address.house_number}` : "";
            partes.push(via + numero);
        }

        // Barrio o zona pequeña
        if (address.suburb) partes.push(address.suburb);
        if (address.neighbourhood) partes.push(address.neighbourhood);

        // Municipio (city/town/village/locality/hamlet)
        const municipio =
            address.city ||
            address.town ||
            address.village ||
            address.locality ||
            address.hamlet;
        if (municipio) partes.push(municipio);

        // Provincia
        if (address.province || address.state) {
            // Hardcoded values
            let provincia = address.province || address.state;
            if (provincia.toLowerCase() === 'comunidad de madrid') {
                provincia = 'Madrid';
            }
            if (provincia.toLowerCase() === 'región de murcia') {
                provincia = 'Murcia';
            }
            partes.push(provincia);
        }

        // CP
        if (address.postcode) partes.push(address.postcode);

        return partes.join(", ");
    }

    generateShortAddressForSelection(ref, showEscalera = true, showIndependiente = false){

        console.log('ref', ref);
        const todoCheck = (ref.partes_direccion.escalera ?? '') + (ref.partes_direccion.planta ?? '') + (ref.partes_direccion.puerta ?? '');
        if (todoCheck.toLowerCase() === 'todo'){
            if (showIndependiente) return 'Independiente';
            return '';
        }


        // Build address parts
        const escalera = showEscalera && ref.partes_direccion.escalera ? 
            'Escalera ' + (parseInt(ref.partes_direccion.escalera, 10) || ref.partes_direccion.escalera) : '';
            
        const planta = ref.partes_direccion.planta === '00' ? 
            'Bajo' : 
            parseInt(ref.partes_direccion.planta ?? '', 10) ? 
                parseInt(ref.partes_direccion.planta ?? '', 10) + 'º' : 
                (ref.partes_direccion.planta ?? '');
            
        const puerta = parseInt(ref.partes_direccion.puerta ?? '', 10) || (ref.partes_direccion.puerta ?? '');

        // Combine parts into full address string
        let result = [];
        if (escalera) result.push(escalera);
        if (planta) result.push(planta);
        if (puerta) result.push(puerta);
        const res = result.join(', ');

        if (res == '' && showIndependiente) return 'Independiente';
        return res;
    }

    handleAddressYesNoCheck(){
        const radioChecked = document.querySelector('input[name="address_check"]:checked');
        const isAddressOk = radioChecked?.value || false;
        console.log("IS ADDRESS OK", isAddressOk, radioChecked);
        if (isAddressOk == '1') {
            this.setSelectedAddress(this.oldAddress);
            this.showAddressOKBlock();
        } else {
            this.showAddressManualBlock();
        }
    }

    async handleAddressCheck() {

        if (this.isSubmiting) {
            return;
        }

        // Abortar la petición anterior si existe
        if (this.currentAddressRequest) {
            this.currentAddressRequest.abort();
            this.currentAddressRequest = null;
            console.log('Búsqueda de dirección anterior cancelada');
        }

        const direccion = this.elements.direccionRC?.value?.trim();
        
        if (!direccion) {
            // this.showError('Debe introducir la referencia catastral o la dirección');
            return;
        }

        try {
            this.showDivAddressLoading();
            DOMHelpers.setRadioValue(this.elements.addressYesNoRadios, '1');
            
            // Crear un AbortController para esta petición
            const abortController = new AbortController();
            this.currentAddressRequest = abortController;
            
            // Al teclear en el campo direccion_rc se pone 'osm' por defecto
            this.typeRequest = 'osm';

            const response = await this.apiClient.parseAddress(direccion, this.typeRequest, {
                signal: abortController.signal
            });

            console.log("RESPONSE", response);
            
            if (response.success && response.data) {
                this.resultsAjax = response.data;

                // Si hubo error !!
                if (this.resultsAjax && this.resultsAjax.status == 'error') {
                    this.handleAddressErrorResponse(this.resultsAjax);

                } else {
                    if (response.data.type == 'rc'){
                        this.handleTypeCatastroResponse();
                    } else if (response.data.type == 'osm'){
                        this.handleTypeOSMResponse(response);
                    }
                }


            } else {
                console.log("Error al buscar la dirección:", response);
                if (response.message && response.message == "Token de seguridad inválido"){
                    this.showError('Su sesión ha expirado, por favor recargue la página e inténtelo de nuevo.');
                    location.href = location.href;
                    return;
                } else {
                    // this.showError('No se pudo procesar la dirección');
                }
                this.showAddressNoAddressBlock();
            }
        } catch (error) {
            // Si el error es por abort, no mostrar error
            if (error.name === 'AbortError') {
                console.log('Búsqueda de dirección cancelada por nueva petición');
                return;
            }
            
            console.error('Error al procesar la dirección:', error);
            this.showError('Error al procesar la dirección');
            this.showAddressNoAddressBlock();
        } finally {
            // Limpiar la referencia de la petición actual
            if (this.currentAddressRequest) {
                this.currentAddressRequest = null;
                this.hideDivAddressLoading();
            }
        }
    }

    handleAddressErrorResponse(response) {
        this.hideAllBlocks();
        this.showAddressNoAddressBlock();
        this.showError(response.data.message);
    }

    handleTypeOSMResponse(){
        // Se muestran las opciones en una lista con todos los detalles de OSM en cuadro azul
        // Al pulsar alguna dirección se manda buscarla en catastro por type=address => this.typeRequest = 'catastro';

        console.log("OSM Addresses", this.resultsAjax);
        this.elements.osmSelectionOptions.innerHTML = '';
        this.elements.osmResultsText.innerHTML = '';

        if (this.resultsAjax.addresses && this.resultsAjax.addresses.length >= 1) {

            const totalResults = this.resultsAjax.addresses.length;
            const maxResults = 10;
            const addressesToShow = this.resultsAjax.addresses.slice(0, maxResults);

            if (totalResults > 10){
                // Añadir mensaje informativo
                const messageHTML = `
                    <p>Mostramos los primeros <b>${maxResults}</b> resultados de un total de <b>${totalResults}</b> encontrados. Por favor, facilítanos más detalles de la dirección para afinar la búsqueda.</p>
                `;
                this.elements.osmResultsText.insertAdjacentHTML('beforeend', messageHTML);
            }

            // Mostrar solo los primeros 10 resultados
            addressesToShow.forEach((address, index) => {

                const dir = address.display_name ?? this.generateOSMAddress(address.address);

                this.elements.osmSelectionOptions.insertAdjacentHTML('beforeend', `<div class="tasaciones-osm-option" data-address-idx="${index}">${dir}</div>`);

            });
            
            this.showOSMSelectionBlock();
        
        } else {

            this.showAddressNoAddressBlock();

        }

    }

    handleTypeCatastroResponse(){
        // Se muestran las opciones en una lista con todos los detalles de OSM en cuadro azul
        // Al pulsar alguna dirección se manda busacarla en catastro por type=address => this.typeRequest = 'catastro';

        // La selección 

        // if (this.resultsAjax && this.resultsAjax.status == 'ok'){

            if (this.resultsAjax && this.resultsAjax.addresses && this.resultsAjax.addresses.length > 1) {
                
                // Si encontró una referencia entre todas las posibles
                if (this.resultsAjax.found_rc){
                    // Buscar la rc encontrada en el array this.resultsAjax
                    const found = this.resultsAjax.addresses.find(ref => ref.referencia_catastral === this.resultsAjax.found_rc);
                    // Rellenar directamente los campos
                    this.setSelectedAddress(found);
                    
                    this.showAddressOKBlock();
    
                    this.showMessage('Encontrada una coincidencia', 'success');
    
                } else {
                    // Mostrar selector de unidades
                    this.setSelectedAddress(this.resultsAjax.addresses[0]);
                    
                    this.showAddressOKBlock();
    
                    this.showMessage('Se encontraron múltiples direcciones, por favor seleccione la correcta', 'success');
                }
    
                this.loadAllOccurrences();
                this.showAddressSelectionBlock();
    
            } else if (this.resultsAjax && this.resultsAjax.addresses && this.resultsAjax.addresses.length === 1) {
                // Rellenar directamente los campos
                this.setSelectedAddress(this.resultsAjax.addresses[0]);
                this.showAddressOKBlock();
                this.showMessage('Dirección verificada correctamente', 'success');
            } else {
                // No se encontró dirección
                this.clearSelectedAddress();
                this.showAddressNoAddressBlock();
            }

        // }
    }

    loadAllOccurrences(){

        this.elements.addressSelectionOptions.innerHTML = '';
        
        // Agrupar direcciones por escalera
        const addressesByEscalera = {};
        
        this.resultsAjax.addresses.forEach(address => {
            const dir = this.generateShortAddressForSelection(address, false);

            let escalera = 'Sin escalera';
            if (dir !== ''){
                escalera = address.partes_direccion.escalera || 'Sin escalera';
            }
            
            if (!addressesByEscalera[escalera]) {
                addressesByEscalera[escalera] = [];
            }
            
            addressesByEscalera[escalera].push(address);
        });
        
        // Ordenar las escaleras (numéricas primero, luego alfabéticamente)
        const escalerasOrdenadas = Object.keys(addressesByEscalera).sort((a, b) => {
            // Si ambas son "Sin escalera", mantener orden
            if (a === 'Sin escalera' && b === 'Sin escalera') return 0;
            // "Sin escalera" va al final
            if (a === 'Sin escalera') return 1;
            if (b === 'Sin escalera') return -1;
            
            // Intentar convertir a número para ordenación numérica
            const numA = parseInt(a, 10);
            const numB = parseInt(b, 10);
            
            // Si ambos son números, ordenar numéricamente
            if (!isNaN(numA) && !isNaN(numB)) {
                return numA - numB;
            }
            
            // Si solo uno es número, el número va primero
            if (!isNaN(numA)) return -1;
            if (!isNaN(numB)) return 1;
            
            // Si ninguno es número, ordenar alfabéticamente
            return a.localeCompare(b);
        });
        
        // Crear los elementos HTML agrupados por escalera
        escalerasOrdenadas.forEach(escalera => {
            // Ordenar direcciones dentro de cada escalera por piso y luego por puerta
            const direccionesOrdenadas = addressesByEscalera[escalera].sort((a, b) => {
                const pisoA = a.partes_direccion.planta || '00';
                const pisoB = b.partes_direccion.planta || '00';
                const puertaA = a.partes_direccion.puerta || '';
                const puertaB = b.partes_direccion.puerta || '';
                
                // Primero ordenar por piso
                const numPisoA = parseInt(pisoA, 10);
                const numPisoB = parseInt(pisoB, 10);
                
                // Si ambos pisos son números, ordenar numéricamente
                if (!isNaN(numPisoA) && !isNaN(numPisoB)) {
                    if (numPisoA !== numPisoB) {
                        return numPisoA - numPisoB;
                    }
                } else {
                    // Si solo uno es número, el número va primero
                    if (!isNaN(numPisoA)) return -1;
                    if (!isNaN(numPisoB)) return 1;
                    
                    // Si ninguno es número, ordenar alfabéticamente
                    const pisoComparison = pisoA.localeCompare(pisoB);
                    if (pisoComparison !== 0) {
                        return pisoComparison;
                    }
                }
                
                // Si los pisos son iguales, ordenar por puerta
                const numPuertaA = parseInt(puertaA, 10);
                const numPuertaB = parseInt(puertaB, 10);
                
                // Si ambas puertas son números, ordenar numéricamente
                if (!isNaN(numPuertaA) && !isNaN(numPuertaB)) {
                    return numPuertaA - numPuertaB;
                }
                
                // Si solo una es número, el número va primero
                if (!isNaN(numPuertaA)) return -1;
                if (!isNaN(numPuertaB)) return 1;
                
                // Si ninguna es número, ordenar alfabéticamente
                return puertaA.localeCompare(puertaB);
            });
            
            // Solo mostrar título de escalera si hay más de una escalera o si no es "Sin escalera"
            if (escalerasOrdenadas.length > 1 || escalera !== 'Sin escalera') {
                const tituloEscalera = escalera === 'Sin escalera' ? 'Sin escalera' : `Escalera ${escalera}`;
                this.elements.addressSelectionOptions.insertAdjacentHTML('beforeend', 
                    `<div class="tasaciones-escalera-title">${tituloEscalera}</div>`
                );
            }
            
            // Agregar los botones de cada dirección
            direccionesOrdenadas.forEach(address => {
                const dir = this.generateShortAddressForSelection(address, false, true);
                this.elements.addressSelectionOptions.insertAdjacentHTML('beforeend', 
                    `<div class="tasaciones-address-option" data-address-id="${address['referencia_catastral']}">${dir}</div>`
                );
            });
        });
    }

    handleAddressSelection(e){
        // Buscar el elemento padre más cercano con la clase tasaciones-address-option
        const item = e.target.closest('.tasaciones-address-option');

        if (item){

            e.preventDefault();
            const addressId = item.dataset.addressId;
            const address = this.resultsAjax.addresses.find(ref => ref.referencia_catastral === addressId);
            this.setSelectedAddress(address);
            this.showAddressOKBlock();
        }
    }

    setSelectedAddress(address) {
        
        if (!address) return;

        this.selectedReference = address;
        
        // Rellenar campos de dirección encontrada
        const dir = this.generateFullAddress(address);
        DOMHelpers.setHTML(this.elements.foundAddress, dir);//address.direccion_completa);
        
        // Rellenar campos ocultos
        DOMHelpers.setValue(this.elements.referenciaCatastral, address.referencia_catastral);
        DOMHelpers.setValue(this.elements.superficieCatastro, address.info.superficie);
        DOMHelpers.setValue(this.elements.uso, address.info.uso);
        DOMHelpers.setValue(this.elements.coeficienteParticipacion, address.info.coeficiente_participacion);
        DOMHelpers.setValue(this.elements.anoConstruccion, address.info.ano_construccion);


        DOMHelpers.setValue(this.elements.dirNumero, address.partes_direccion.numero);
        DOMHelpers.setValue(this.elements.dirEscalera, address.partes_direccion.escalera);
        DOMHelpers.setValue(this.elements.dirPlanta, address.partes_direccion.planta);
        DOMHelpers.setValue(this.elements.dirPuerta, address.partes_direccion.puerta);
        DOMHelpers.setValue(this.elements.codigoPostal, address.partes_direccion.codigo_postal);
        DOMHelpers.setValue(this.elements.dirTipoVia, address.partes_direccion.tipo_via);
        DOMHelpers.setValue(this.elements.dirNombreVia, address.partes_direccion.nombre_via);
        DOMHelpers.setValue(this.elements.municipio, address.partes_direccion.municipio);
        DOMHelpers.setValue(this.elements.provincia, address.partes_direccion.provincia);
        
        DOMHelpers.setValue(this.elements.dirNumero2, address.partes_direccion.numero);
        DOMHelpers.setValue(this.elements.dirEscalera2, address.partes_direccion.escalera);
        DOMHelpers.setValue(this.elements.dirPlanta2, address.partes_direccion.planta);
        DOMHelpers.setValue(this.elements.dirPuerta2, address.partes_direccion.puerta);

        console.log(address.partes_direccion);
        
    }

    async handleOSMAddressSelection(e){
        // Buscar el elemento padre más cercano con la clase tasaciones-osm-option
        const item = e.target.closest('.tasaciones-osm-option');

        if (item){

            e.preventDefault();
            const addressIdx = item.dataset.addressIdx;
            const address = this.resultsAjax.addresses[addressIdx];
            

            this.showAddressLoading(true);

            // Crear un AbortController para esta petición
            const abortController = new AbortController();
            this.currentCatastroRequest = abortController;

            const response = await this.apiClient.parseOSMAddress(address, {
                signal: abortController.signal
            });

            this.showAddressLoading(false);

            console.log()
            if (response && response.data && response.data.addresses) {

                // Si ha encontrado en catastro guardamos el resultado
                if (response.data.addresses.length > 0) {
                    this.resultsAjax = response.data;

                    if (response.data.addresses.length == 1) {
                        this.setSelectedAddress(response.data.addresses[0]);
                        // address es una dirección de OSM, necesitamos la estructura que viene del servidor
                        this.setSelectedAddress(response.data.addresses[0]);
                        this.showAddressOKBlock();
    
                    } else if (response.data.addresses.length > 1) {
                        // Mostrar todas las opciones para seleccionar
                        this.setSelectedAddress(response.data.addresses[0]);
                        this.loadAllOccurrences();
                        this.showAddressSelectionBlock();
                    }

                } else {

                    // Da igual que no esté en catastro, continuamos pidiéndole escalera, piso y puerta
                    this.resultsAjax.addresses = [this.convertOSMtoAddress(address)];
                    this.setSelectedAddress(this.resultsAjax.addresses[0]);
                    this.showExtraFormBlock();

                }

            } 
            

            
        }
    }

    convertOSMtoAddress(osmAddress){

        // La plantilla a devolver es esta
        console.log("OSM ADDRESS: ", osmAddress);

        const partes_direccion = {
            codigo_postal: osmAddress.address.postcode ?? '',
            provincia: osmAddress.address.province ??
                        osmAddress.address.county ??
                        osmAddress.address.state ?? '',
            municipio: osmAddress.address.hamlet ?? 
                        osmAddress.address.locality ?? 
                        osmAddress.address.village ??
                        osmAddress.address.town ?? 
                        osmAddress.address.city ?? 
                        osmAddress.address.municipality ?? '',
            tipo_via: '',
            nombre_via: osmAddress.address.road ??
                        osmAddress.address.pedestrian ?? '',
            numero: osmAddress.address.house_number ?? '',
            escalera: '',
            planta: '',
            puerta: '',
        };

        // Ajustar provincia
        if (partes_direccion.provincia.toLowerCase().startsWith('comunidad de')) {
            const n = partes_direccion.provincia.toLowerCase().replace('comunidad de', '').trim();
            partes_direccion.provincia = n.charAt(0).toUpperCase() + n.slice(1);
        }
        if (partes_direccion.provincia.toLowerCase() === 'región de murcia') {
            partes_direccion.provincia = 'Murcia';
        }

        return {
            referencia_catastral: '',
            direccion_completa: osmAddress.display_name,
            partes_direccion: partes_direccion,
            info: {
                uso: '',
                superficie: '',
                coeficiente_participacion: '',
                ano_construccion: '',
            }
        }
    }

    clearSelectedAddress() {
        
        this.oldAddress = this.selectedReference;
        this.selectedReference = null;

        
        DOMHelpers.setText(this.elements.foundAddress, '');
        
        // Rellenar campos ocultos
        // No usamos la RC encontrada porque no sabemos si es correcta, solo la usamos si él la teclea
        DOMHelpers.setValue(this.elements.referenciaCatastral, '');
        DOMHelpers.setValue(this.elements.superficieCatastro, '');
        DOMHelpers.setValue(this.elements.uso, '');
        DOMHelpers.setValue(this.elements.coeficienteParticipacion, '');
        DOMHelpers.setValue(this.elements.anoConstruccion, '');


        DOMHelpers.setValue(this.elements.dirNumero, '');
        DOMHelpers.setValue(this.elements.dirEscalera, '');
        DOMHelpers.setValue(this.elements.dirPlanta, '');
        DOMHelpers.setValue(this.elements.dirPuerta, '');
        DOMHelpers.setValue(this.elements.codigoPostal, '');
        DOMHelpers.setValue(this.elements.municipio, '');
        DOMHelpers.setValue(this.elements.dirTipoVia, '');
        DOMHelpers.setValue(this.elements.dirNombreVia, '');

        DOMHelpers.setValue(this.elements.dirNumero2, '');
        DOMHelpers.setValue(this.elements.dirEscalera2, '');
        DOMHelpers.setValue(this.elements.dirPlanta2, '');
        DOMHelpers.setValue(this.elements.dirPuerta2, '');
        
        DOMHelpers.setValue(this.elements.provincia, '');

        DOMHelpers.setValue(this.elements.municipio, '');
        
    }

    handleMoreLegales() {
        let isShown = DOMHelpers.isVisible(this.elements.legalesContainer);
        if (isShown) {
            DOMHelpers.hide(this.elements.legalesContainer);
            this.elements.moreLegalesBtn.innerHTML = this.legalesOriginalIconHTML;
        } else {
            DOMHelpers.show(this.elements.legalesContainer);
            this.elements.moreLegalesBtn.innerHTML = this.legalesOpenIconText;
        }
    }

    handleRecibirInformeChange() {
        if (this.elements.recibirInformeCheckbox.checked) {
            // Checkea todos los checkboxes dentro de legalesContainer
            this.elements.legalesContainerCheckboxes.forEach(checkbox => {
                checkbox.checked = true;
            });
        } else {
            // Descheckea todos los checkboxes dentro de legalesContainer
            this.elements.legalesContainerCheckboxes.forEach(checkbox => {
                checkbox.checked = false;
            });
        }
    }

    handleLegalesChange(item) {
        if (item.checked) {
            this.elements.recibirInformeCheckbox.checked = true;
        }
    }


    validateFormField(field) {
        console.log('Validando campo', field.name);
        // Valida el formulario cada vez que un campo pierde el foco
        const formData = new FormData();
        formData.append(field.name, field.value);
        this.formValidator.validate(formData);

        this.validateForm();
    }

    validateForm() {
        // Validar el formulario y devolver true si es válido, false si no
        const formData = new FormData(this.elements.form);
        const errors = this.formValidator.validate(formData, false);
        if (errors.length > 0) {
            this.elements.submitBtn.classList.add('disabled');
        } else {
            this.elements.submitBtn.classList.remove('disabled');
        }
        return errors.length === 0;
    }

    handleFormSubmit(event) {

        if (this.isLoading()) {
            event.preventDefault();
            return;
        }
        this.isSubmiting = true;
        // console.log("result ajax", this.resultsAjax);
        // const formData = new FormData(this.elements.form);
        // console.log("formData", formData);

        //  event.preventDefault();
        // return;

        console.log('Form Submit', this.stateIntroduction);
        if (this.stateIntroduction == 'osm'){
            // copio los valores de formulario de escalera, planta y puerta a los campos de manual
            DOMHelpers.setValue(this.elements.dirNumero, this.elements.dirNumero2.value);
            DOMHelpers.setValue(this.elements.dirEscalera, this.elements.dirEscalera2.value);
            DOMHelpers.setValue(this.elements.dirPlanta, this.elements.dirPlanta2.value);
            DOMHelpers.setValue(this.elements.dirPuerta, this.elements.dirPuerta2.value);
        }

        try {
            const formData = new FormData(this.elements.form);
            
            let errors = this.formValidator.validate(formData);
            console.log('Errores:', errors);



            if (errors.length > 0) {
                event.preventDefault();

                this.isSubmiting = false;

                if (this.stateIntroduction == 'osm'){
                    if (errors.length == 1 && errors[0].field == 'dir_numero'){
                        // La validación añade los mensajes de error a dir_numero no a dir_numero2
                        
                    }
                }

                // si hay errores en los campos de la dirección, mostrar el contenedor de la dirección
                if (errors.some(error => error.field.startsWith('dir_') || error.field == 'provincia' || error.field == 'municipio' || error.field == 'codigo_postal' )) {
                    this.stateIntroduction = 'manual';
                    this.showAddressManualEditOnError();
                }
                return false;
            }

            

            // Al terminar la función sin event.preventDefault(); se envía el formulario.
            this.showLoading(true);
            
        } catch (error) {
            event.preventDefault();
            this.isSubmiting = false;
            this.showError('Error al guardar los datos');
            return false;
        }
    }
}

// Hacer la clase disponible globalmente
window.TasacionesFunnelStep1 = TasacionesFunnelStep1;
